// The planning areas, shared by the catalog and the first conversation's suggestions. A
// fixed table: each area lists the topics that belong in it, by key.
export const AREAS: readonly {
  title: string;
  description: string;
  topics: readonly string[];
}[] = [
  {
    title: 'Your estate and legacy',
    description:
      'Plan what you leave behind and how the people you care about are provided for.',
    topics: ['loved_ones', 'property', 'estate_wishes'],
  },
  {
    title: 'Your future care',
    description:
      'Think through how you’d want to live and who could help if your needs change.',
    topics: ['living', 'support', 'paying_for_care'],
  },
  {
    title: 'Your medical wishes',
    description:
      'Clarify the medical care you’d want and who could make decisions for you.',
    topics: ['medical_care', 'medical_wishes'],
  },
  {
    title: 'After your death',
    description:
      'Prepare personal wishes and practical information for the people you leave behind.',
    topics: ['funeral', 'documents', 'messages'],
  },
];

/** The title of the area a topic belongs to, or null when no area lists it. */
export function areaFor(topicKey: string): string | null {
  return AREAS.find((area) => area.topics.includes(topicKey))?.title ?? null;
}
